import React from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Box, Typography, CircularProgress } from '@mui/material';
import { liveAnalyticsAPI } from '../../services/liveAnalyticsApi';

const EnrollmentChart: React.FC = () => {
  const { data: enrollmentData, isLoading, error } = useQuery({
    queryKey: ['liveEnrollmentTrends'],
    queryFn: () => liveAnalyticsAPI.getEnrollmentTrends()
  });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <Typography color="error">Failed to load enrollment data</Typography>
      </Box>
    );
  }

  const data = enrollmentData?.data?.trends || [];

  return (
    <Box sx={{ height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip formatter={(value: number) => value.toLocaleString()} />
          <Legend />
          <Line
            type="monotone"
            dataKey="pre_primary"
            stroke="#9c27b0"
            strokeWidth={2}
            name="Pre-Primary"
          />
          <Line
            type="monotone"
            dataKey="primary"
            stroke="#1976d2"
            strokeWidth={2}
            name="Primary"
          />
          <Line
            type="monotone"
            dataKey="secondary"
            stroke="#dc004e"
            strokeWidth={2}
            name="Secondary"
          />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#2e7d32"
            strokeWidth={2}
            name="Total"
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default EnrollmentChart;